export const hotTopics = [
  { id: 1, title: '小甜甜塌房事件', heat: 128450, trend: 'up' },
  { id: 2, title: '顶流男星地下恋情', heat: 256780, trend: 'up' },
  { id: 3, title: '网红离婚潮', heat: 189450, trend: 'up' },
  { id: 4, title: '直播打赏骗局', heat: 145670, trend: 'down' },
  { id: 5, title: '合约恋爱曝光', heat: 167890, trend: 'stable' },
  { id: 6, title: '选秀节目黑幕', heat: 112340, trend: 'up' },
  { id: 7, title: '主播偷税调查', heat: 98760, trend: 'up' },
  { id: 8, title: '清纯校花海王', heat: 156230, trend: 'down' },
  { id: 9, title: '算法流量黑幕', heat: 76500, trend: 'up' },
  { id: 10, title: '直播带货套路', heat: 134560, trend: 'stable' },
];